import React from 'react';
import InputAdornment from '@mui/material/InputAdornment';
import OutlinedInput from '@mui/material/OutlinedInput';
import FormControl from '@mui/material/FormControl';
import Typography from '@mui/material/Typography';
import ComponentHeaderTitles from '../ComponentHeaderTitles';
import { useState } from 'react';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { useEffect } from 'react';
import FormHelperText from '@mui/material/FormHelperText';


function TerugleveringInput({ returnedEnergyAmount, setReturnedEnergyAmount }) {

  const [modalOpen, setModalOpen] = useState(false);
  const [solarPanels, setSolarPanels] = useState(0);
  const [estimatedReturns, setEstimatedReturns] = useState({ high: 0, low: 0 });
  const [terugleveringHoogError, setTerugleveringHoogError] = useState(false);
  const [terugleveringLaagError, setTerugleveringLaagError] = useState(false);

  const handleModalOpen = () => setModalOpen(true);
  const handleModalClose = () => setModalOpen(false);

  const handleSolarPanelsChange = (value) => {
    const newValue = value.trim();
    const re = /^[0-9\b]+$/;
    // If value is empty or passes the regex test, update the state
    if ((value === '' || (re.test(value) && value <= 100))) {

      const base = (value * 240) / 7;
      setSolarPanels(value);
      setEstimatedReturns({
        high: Math.round(base * 5),
        low: Math.round(base * 2),
      });
    }
  };

  const handleSaveEstimate = () => {
    setReturnedEnergyAmount({
      ...returnedEnergyAmount,
      return_high: estimatedReturns.high.toString(),
      return_low: estimatedReturns.low.toString(),
    });
    handleModalClose();
  };


  const handleChange = (field, value) => {
    const newValue = value.trim();
    const re = /^[0-9\b]+$/;
    // If value is empty or passes the regex test, update the state
    if (newValue === "" || re.test(newValue)) {
      setReturnedEnergyAmount((prevState) => ({
        ...prevState,
        [field]: value.trim() === '' ? null : value,
      }));
    }
  };

  const handleOnBlur = (field, value) => {

    // if empty
    if (value === "") {
      if (field == "return_high") {
        setTerugleveringHoogError(true);
      }
      if (field == "return_low") {
        setTerugleveringLaagError(true);
      }
    } else {
      if (field == "return_high") {
        setTerugleveringHoogError(false);
      }
      if (field == "return_low") {
        setTerugleveringLaagError(false);
      }
    }
  };

  useEffect(() => {
    // This code will run on mount and whenever `returnedEnergyAmount` changes
    // Check if returnedEnergyAmount exists and has the properties return_high and return_low
    // If not, set them to null
    if (!returnedEnergyAmount || !returnedEnergyAmount.return_high || !returnedEnergyAmount.return_low) {
      setReturnedEnergyAmount(prevState => ({
        ...prevState,
        return_high: null,
        return_low: null
      }));
    }
  }, []); // An empty dependencies array ensures this effect only runs once on mount


  return (
    <div class="teruglevering-container">
      <ComponentHeaderTitles title="Teruglevering per jaar" />
      <div className="teruglevering-hoog">
        <FormControl variant="outlined">
          <Typography variant="caption" color="textSecondary">
            Teruglevering hoog (per jaar)
          </Typography>
          <OutlinedInput
              type="text"
              id="outlined-adornment-weight"
              placeholder="0000"
              endAdornment={<InputAdornment position="end">kWh</InputAdornment>}
              startAdornment={
                <InputAdornment position="start">
                  <span className="icon-as-stroomlicht icon-size" />
                </InputAdornment>
              }
              aria-describedby="outlined-weight-helper-text"
              className="verbruik-input"
              inputProps={{
                'aria-label': 'weight',
                inputMode: "numeric"
              }}
              value={returnedEnergyAmount && returnedEnergyAmount.return_high ? returnedEnergyAmount.return_high : ''}
              onBlur={(e) => handleOnBlur('return_high', e.target.value)}
              error={terugleveringHoogError}
              onChange={(e) => handleChange('return_high', e.target.value)}
          />
          {terugleveringHoogError && (
              <FormHelperText error={terugleveringHoogError}>
                Gelieve je je hoog stroomverbruik teruglevering in te vullen. Lever je geen hoog stroom terug? Vul dan 0 in.
              </FormHelperText>
          )}

        </FormControl>
      </div>
      <div class="teruglevering-laag">
        <FormControl variant="outlined">
          <Typography variant="caption" color="textSecondary">
            Teruglevering laag (per jaar)
          </Typography>
          <OutlinedInput
            type="text"
            id="outlined-adornment-weight"
            endAdornment={<InputAdornment position="end">kWh</InputAdornment>}
            aria-describedby="outlined-weight-helper-text"
            placeholder="0000"
            startAdornment={
              <InputAdornment position="start">
                <span className="icon-as-stroomlicht icon-size" />
              </InputAdornment>
            }
            className="verbruik-input"
            inputProps={{
              'aria-label': 'weight',
              inputMode: "numeric"
            }}
            value={returnedEnergyAmount && returnedEnergyAmount.return_low ? returnedEnergyAmount.return_low : ''}
            onBlur={(e) => handleOnBlur('return_low', e.target.value)}
            error={terugleveringLaagError}
            onChange={(e) => handleChange('return_low', e.target.value)}
          />
          {terugleveringLaagError && (
            <FormHelperText error={terugleveringLaagError}>
              Gelieve je je laag stroomverbruik teruglevering in te vullen. Lever je geen laag stroom terug? Vul dan 0 in.
            </FormHelperText>
          )}
        </FormControl>
        <div className="help-mij-met-inschatten">
          <a onClick={handleModalOpen} style={{ cursor: 'pointer' }}>
            help mij met inschatten
          </a>
        </div>
        <Modal open={modalOpen} onClose={handleModalClose}>
          <Box className="teruglevering-inschatting" position="relative">
            <div
                className="icon-as-close icon-size closeButton"
                onClick={handleModalClose}
                style={{ position: 'absolute', right: '10px', top: '10px', cursor: 'pointer', width: '2rem', height: '2rem' }}
            ></div>
            <Typography className="modal-header" variant="h6">Zonnepanelen schatting</Typography>
            <Typography className="modal-body">Voer het aantal zonnepanelen in om de teruglevering te schatten. De berekening wordt hieronder gelijk weergegeven.</Typography>
            <OutlinedInput
                type="number"
                value={solarPanels}
                onChange={(e) => handleSolarPanelsChange(e.target.value)}
                inputProps={{ max: 100, min: 0 }}
                endAdornment={<InputAdornment position="end">panelen</InputAdornment>}
                aria-describedby="panelen-helper-text"
            />
            <FormHelperText id="panelen-helper-text">Maximaal 100 panelen.</FormHelperText>
            <Typography variant="subtitle1" className="teruglevering-schatting">Geschatte teruglevering:</Typography>
            <Typography>Teruglevering hoog: <strong>{estimatedReturns.high} kWh </strong></Typography>
            <Typography>Teruglevering laag: <strong>{estimatedReturns.low} kWh </strong></Typography>

            <div className="navigation">
              <a onClick={handleModalClose}>Annuleer</a>
              <a onClick={handleSaveEstimate} className='btn btn-primary'>Gebruik schatting</a>
            </div>
          </Box>
        </Modal>
      </div>

    </div>
  );
}

TerugleveringInput.displayName = 'TerugleveringInput';
export default TerugleveringInput;
